import * as Sentry from "@sentry/react";
import { useMemo } from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { MainLayout } from "../layouts/main/MainLayout";
import { useAppRoutes } from "./useAppRoutes";

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

export const AppRouterProvider = () => {
  const routes = useAppRoutes();
  const router = useMemo(
    () => sentryCreateBrowserRouter([{ element: <MainLayout />, children: routes }]),
    [routes]
  );

  return <RouterProvider router={router} />;
};
